import React from 'react';
import { Briefcase, Calendar } from 'lucide-react';
import { experience } from '../data/mock';

const Experience = () => {
  return (
    <section id="experience" className="py-24 lg:py-32 bg-[#232323] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(255,255,255,0.5)] mb-4 block">Career</span>
          <h2 className="section-title text-white">Experience</h2>
        </div>

        {/* Timeline */}
        <div className="space-y-0">
          {experience.map((exp, idx) => (
            <div
              key={exp.id}
              className="relative group"
            >
              {/* Timeline Line */}
              {idx !== experience.length - 1 && (
                <div className="absolute left-[19px] top-16 bottom-0 w-px bg-[rgba(255,255,255,0.1)]" />
              )}

              <div className="flex gap-6 lg:gap-10 pb-12">
                {/* Timeline Dot */}
                <div className="flex-shrink-0 relative z-10">
                  <div className="w-10 h-10 bg-[#38FF62] flex items-center justify-center">
                    <Briefcase className="w-5 h-5 text-[#232323]" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 pt-1">
                  {/* Header */}
                  <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 mb-4">
                    <div>
                      <h3 className="font-display text-xl lg:text-2xl font-semibold text-white mb-1">
                        {exp.role}
                      </h3>
                      <p className="font-body text-lg text-[#38FF62]">
                        {exp.company}
                      </p>
                    </div>
                    <div className="flex items-center gap-4">
                      <span className="px-3 py-1 border border-[rgba(255,255,255,0.2)] font-mono text-xs uppercase">
                        {exp.type}
                      </span>
                      <div className="flex items-center gap-2 text-[rgba(255,255,255,0.5)]">
                        <Calendar className="w-4 h-4" />
                        <span className="font-mono text-xs">{exp.duration}</span>
                      </div>
                    </div>
                  </div>

                  {/* Responsibilities */}
                  <ul className="space-y-3">
                    {exp.responsibilities.map((resp, respIdx) => (
                      <li key={respIdx} className="flex items-start gap-3">
                        <span className="w-1.5 h-1.5 bg-[#38FF62] mt-2 flex-shrink-0"></span>
                        <span className="font-body text-[rgba(255,255,255,0.7)]">
                          {resp}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;